(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-steps"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('[data-steps-section]');
  if (!sections.length) return;

  var prefersReducedMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(section) {
    if (section.dataset.stepsRevealed === 'true') return;
    section.dataset.stepsRevealed = 'true';
    var els = section.querySelectorAll('.steps-reveal');
    els.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    sections.forEach(reveal);
    return;
  }

  var io = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
  );

  sections.forEach(function (section) {
    io.observe(section);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
